module.exports = __webpack_public_path__ + "assets/img/Type E (38).13cd2d02.jpg";